import { render, staticRenderFns } from "./resource-filter.vue?vue&type=template&id=4fafde69&scoped=true&"
import script from "./resource-filter.vue?vue&type=script&lang=ts&"
export * from "./resource-filter.vue?vue&type=script&lang=ts&"
import style0 from "./resource-filter.vue?vue&type=style&index=0&id=4fafde69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fafde69",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
